module.exports = __webpack_public_path__ + "media/img/logos/2023/horizontal/valentine-55d3c2a62bf7bf6f2ec1026870362762.svg";